import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';
import DonationButton from './DonationButton';
import { Link, useLocation } from 'react-router-dom';
import { IoGlasses } from "react-icons/io5";
import Footer from './Footer';

function MergePdfs() {
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const isMainPage = location.pathname === '/';

  const handlePdfUpload = async (event) => {
    const files = Array.from(event.target.files);
    const pdfPromises = files.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve({
          name: file.name,
          data: new Uint8Array(e.target.result)
        });
        reader.readAsArrayBuffer(file);
      });
    });

    const results = await Promise.all(pdfPromises);
    setPdfs(prev => [...prev, ...results]);
  };

  const mergePDFs = async () => {
    if (pdfs.length === 0) return;
    
    setLoading(true);
    try {
      const mergedPdf = await PDFDocument.create();
      
      for (const pdf of pdfs) {
        const pdfDoc = await PDFDocument.load(pdf.data);
        const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
        copiedPages.forEach(page => mergedPdf.addPage(page));
      }
      
      const mergedPdfFile = await mergedPdf.save();
      const blob = new Blob([mergedPdfFile], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = 'merged.pdf';
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error merging PDFs:', error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <header className="text-center">
        <Link to="/pdf-tools" className="text-4xl font-bold text-black">
          <div className="flex items-center gap-2 justify-center">
            <IoGlasses size={50} />
            PDF llama
          </div>
        </Link>
        {!isMainPage && (
          <>
            <div className="mt-1">
              <Link to="/pdf-tools" className="text-gray-600 hover:text-gray-800">
                Go to another operations with PDF
              </Link>
            </div>
          </>
        )}
      </header>
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6 mt-2">
        <h1 className="text-3xl font-bold mb-6">Merge PDF Files</h1>
        
        <input
          type="file"
          accept=".pdf"
          multiple
          onChange={handlePdfUpload}
          // className="mb-4"
          className="block w-full text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4
              file:rounded-full file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
        />

        <div className="mb-6">
          {pdfs.map((pdf, index) => (
            <div key={index} className="p-3 bg-gray-50 rounded-lg mb-2">
              {pdf.name}
            </div>
          ))}
        </div>

        <button
          onClick={mergePDFs}
          disabled={loading || pdfs.length < 2}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg mb-6 hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? 'Merging PDFs...' : 'Merge PDFs'}
        </button>

      </div>
      <div className="mt-8">
        <DonationButton />
      </div>

      <article className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-semibold mb-6">
        Merge PDF files online
      </h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Free online tool to join and combine PDF files
        </h2>
        <p className="mb-4">
          Our free online tool makes it 
          easy to combine PDFs instantly and securely
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          How to merge PDF files online
        </h2>
        <div className="space-y-4">
          <h3 className="text-xl font-medium">Easy steps to combine PDFs:</h3>
          <div className="pl-4">
            <p className="mb-2">
              1. Upload your PDF files to PDF llama merger
            </p>
            <p className="mb-2">
              2. Click "Merge PDFs" to combine your documents
            </p>
            <p className="mb-2">
              3. Download your merged PDF file
            </p>
          </div>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Advanced features of our PDF llama merger tool
        </h2>
        <div className="space-y-4">
          <h3 className="text-xl font-medium">Complete PDF management solution:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Merge unlimited PDF files with our free online tool
            </li>
            <li>
              Our tool instantly combines PDFs in few seconds
            </li>
          </ul>
        </div>
      </section>

    </article>

    <Footer />

    </div>
  );
}

export default MergePdfs;
